/* Prime Vitamins theme JS. Motion ported from the approved prototype; commerce via Shopify Cart AJAX API + Section Rendering API. */
(() => {
'use strict';

const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];
const clamp = (n, a, b) => Math.min(b, Math.max(a, n));
const root = document.documentElement;
const reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const P = window.Prime || { routes: {}, strings: {} };

/* ============ Scroll lock / Lenis ============ */
let lenis = null;
const lockScroll = on => { root.classList.toggle('lock', on); if (lenis) on ? lenis.stop() : lenis.start(); };

/* ============ Motion ============ */
const scrubs = [];
let io = null, dirty = true;
function splitWords(el) {
  if (el.dataset.done) return; el.dataset.done = '1';
  const c = el.cloneNode(true); c.querySelectorAll('br').forEach(b => b.replaceWith(' '));
  el.setAttribute('aria-label', c.textContent.replace(/\s+/g, ' ').trim());
  let i = 0; const frag = document.createDocumentFragment();
  [...el.childNodes].forEach(n => {
    if (n.nodeType === 3) {
      n.textContent.split(/(\s+)/).forEach(t => {
        if (!t) return;
        if (/^\s+$/.test(t)) { frag.appendChild(document.createTextNode(' ')); return; }
        const w = document.createElement('span'); w.className = 'w'; w.setAttribute('aria-hidden', 'true');
        const wi = document.createElement('span'); wi.className = 'wi'; wi.textContent = t; wi.style.setProperty('--i', i++);
        w.appendChild(wi); frag.appendChild(w);
      });
    } else frag.appendChild(n.cloneNode(true));
  });
  el.replaceChildren(frag);
}
function scrubWords(el) {
  if (el.dataset.done) return; el.dataset.done = '1';
  const words = el.textContent.trim().split(/\s+/); el.textContent = '';
  const spans = words.map((t, i) => { const s = document.createElement('span'); s.className = 'sw'; s.textContent = t; el.appendChild(s); if (i < words.length - 1) el.appendChild(document.createTextNode(' ')); return s; });
  scrubs.push({ el, words: spans });
}
function motion(scope = document) {
  $$('[data-split]', scope).forEach(splitWords);
  $$('[data-scrub]', scope).forEach(scrubWords);
  const targets = $$('[data-split],[data-fade],.reveal-img', scope).filter(t => !t.classList.contains('in'));
  if (reduced || !('IntersectionObserver' in window)) { targets.forEach(t => t.classList.add('in')); dirty = true; return; }
  if (!io) io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }), { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
  targets.forEach(t => io.observe(t));
  dirty = true;
}
function updateScroll() {
  const vh = window.innerHeight, y = window.scrollY, head = $('#head');
  if (head) head.classList.toggle('stuck', y > 8);
  const backTop = $('[data-back-top]');
  if (backTop) backTop.hidden = y < Math.max(400, vh * 0.6);
  scrubs.forEach(s => {
    if (!s.el.isConnected) return;
    const r = s.el.getBoundingClientRect(); if (r.bottom < -80 || r.top > vh + 80) return;
    const p = reduced ? 1 : clamp((vh * 0.88 - r.top) / (r.height + vh * 0.36), 0, 1), n = s.words.length;
    s.words.forEach((w, i) => { w.style.opacity = (0.14 + 0.86 * clamp((p * (n + 3) - i) / 3, 0, 1)).toFixed(3); });
  });
}
let lastY = -1;
function loop(t) {
  if (lenis) lenis.raf(t);
  const y = window.scrollY;
  if (y !== lastY || dirty) { lastY = y; dirty = false; updateScroll(); }
  requestAnimationFrame(loop);
}

/* ============ Intro (first page of the session only) ============ */
let introGate = Promise.resolve();
function runIntro() {
  const el = document.getElementById('intro'); if (!el) return;
  let seen = root.classList.contains('intro-seen');
  try { sessionStorage.setItem('prime-intro', '1'); } catch (e) {}
  if (reduced || seen) { el.remove(); return; }
  root.classList.add('intro-on'); lockScroll(true);
  introGate = new Promise(res => {
    setTimeout(() => el.classList.add('go'), 1300);
    setTimeout(() => {
      el.classList.add('lift'); root.classList.remove('intro-on');
      setTimeout(res, 380);
      setTimeout(() => { el.remove(); lockScroll(false); }, 1200);
    }, 2250);
  });
}

/* ============ Mobile menu ============ */
function closeMenu() {
  if (!root.classList.contains('menu-open')) return;
  root.classList.remove('menu-open'); $('#menu-btn')?.setAttribute('aria-expanded', 'false'); lockScroll(false);
}
function toggleMenu() {
  const open = !root.classList.contains('menu-open');
  if (open) closeDrawer();
  root.classList.toggle('menu-open', open); $('#menu-btn')?.setAttribute('aria-expanded', String(open)); lockScroll(open);
}

/* ============ Search panel ============ */
function setSearch(open) {
  const panel = $('#search-panel'); if (!panel) return;
  panel.hidden = !open;
  $$('[data-search-toggle]').forEach(b => b.setAttribute('aria-expanded', String(open)));
  if (open) { closeMenu(); $('input[name="q"]', panel)?.focus(); } else if (panel.contains(document.activeElement)) $('[data-search-toggle]')?.focus();
}

/* ============ Contact button ============ */
function setFab(open) {
  const pop = $('#contact-pop'); if (!pop) return;
  pop.hidden = !open;
  $('[data-fab-toggle]')?.setAttribute('aria-expanded', String(open));
}

/* ============ Cart drawer ============ */
let lastFocus = null;
let drawerFocusTimer = null;
let drawerInertState = null;
const drawerFocusableSelector = 'a[href],area[href],button,input,select,textarea,[tabindex],[contenteditable="true"]';

function drawerFocusable(d) {
  if (!d) return [];
  return $$(drawerFocusableSelector, d).filter(el => {
    if (el.disabled || el.hidden || el.getAttribute('aria-disabled') === 'true') return false;
    if (el.tabIndex < 0 || el.getAttribute('aria-hidden') === 'true') return false;
    if (el.tagName === 'INPUT' && el.getAttribute('type') === 'hidden') return false;
    if (el.closest('[hidden],[inert],[aria-hidden="true"]')) return false;
    const style = window.getComputedStyle?.(el);
    return !style || (style.display !== 'none' && style.visibility !== 'hidden');
  });
}

function restoreDrawerInertState() {
  if (!drawerInertState) return;
  drawerInertState.forEach(({ el, inert, hadInertAttribute }) => {
    if (!el.isConnected) return;
    el.inert = inert;
    if (hadInertAttribute) el.setAttribute('inert', ''); else el.removeAttribute('inert');
  });
  drawerInertState = null;
}

function setDrawerBackgroundInert(d, on) {
  if (!document.body) return;
  if (!on) { restoreDrawerInertState(); return; }
  if (drawerInertState) return;
  const scrim = $('#scrim');
  drawerInertState = [];
  [...document.body.children].forEach(el => {
    if (el === d || el === scrim || el.contains(d) || el.contains(scrim)) return;
    drawerInertState.push({ el, inert: el.inert, hadInertAttribute: el.hasAttribute('inert') });
    el.inert = true;
    el.setAttribute('inert', '');
  });
}

function containDrawerFocus(e) {
  const d = $('#drawer');
  if (!d || !d.classList.contains('open')) return;
  if (e.type === 'focusin') {
    if (d.contains(e.target)) return;
    e.stopPropagation();
    (drawerFocusable(d)[0] || d).focus();
    return;
  }
  if (e.key !== 'Tab') return;
  const focusable = drawerFocusable(d);
  if (!focusable.length) { e.preventDefault(); d.focus(); return; }
  const index = focusable.indexOf(document.activeElement);
  const edge = e.shiftKey ? index <= 0 : index === -1 || index === focusable.length - 1;
  if (!edge) return;
  e.preventDefault();
  (e.shiftKey ? focusable[focusable.length - 1] : focusable[0]).focus();
}

function restoreDrawerFocus() {
  const target = lastFocus && lastFocus.isConnected ? lastFocus : $('[data-open-drawer]');
  lastFocus = null;
  if (target && target.focus) target.focus();
}

function openDrawer() {
  const d = $('#drawer'); if (!d) return false;
  closeMenu();
  if (!d.classList.contains('open')) lastFocus = document.activeElement;
  d.classList.add('open'); d.setAttribute('aria-hidden', 'false'); $('#scrim').classList.add('open'); lockScroll(true);
  setDrawerBackgroundInert(d, true);
  if (drawerFocusTimer) clearTimeout(drawerFocusTimer);
  drawerFocusTimer = setTimeout(() => {
    drawerFocusTimer = null;
    const current = $('#drawer');
    if (!current || !current.classList.contains('open')) return;
    ($('#drawer-close') || drawerFocusable(current)[0] || current).focus();
  }, 50);
  return true;
}
function closeDrawer() {
  if (drawerFocusTimer) { clearTimeout(drawerFocusTimer); drawerFocusTimer = null; }
  const d = $('#drawer');
  const hadOpenState = Boolean(drawerInertState || lastFocus);
  if (!d || !d.classList.contains('open')) {
    restoreDrawerInertState();
    if (hadOpenState) restoreDrawerFocus();
    return;
  }
  d.classList.remove('open'); d.setAttribute('aria-hidden', 'true'); $('#scrim')?.classList.remove('open'); lockScroll(false);
  setDrawerBackgroundInert(d, false);
  restoreDrawerFocus();
}
function updateBadge(count, bump) {
  const b = $('#badge'); if (!b) return;
  b.textContent = count; b.hidden = count === 0;
  if (P.strings.openCart) $('#cart-btn')?.setAttribute('aria-label', P.strings.openCart.replace('[count]', count));
  if (bump) { b.classList.remove('bump'); void b.offsetWidth; b.classList.add('bump'); }
}

/* Sections re-rendered after any cart change: the drawer, plus the cart page when present. */
function cartSections() {
  const ids = ['cart-drawer'];
  const main = $('[data-cart-section]'); if (main) ids.push(main.dataset.cartSection);
  return ids;
}
function applySections(sections, bump) {
  if (!sections) return;
  const parse = html => new DOMParser().parseFromString(html, 'text/html');
  if (sections['cart-drawer']) {
    const doc = parse(sections['cart-drawer']);
    const drawerBody = $('#drawer-body');
    const scrollTop = drawerBody?.scrollTop || 0;
    const active = document.activeElement;
    const activeLine = active?.closest?.('[data-line]');
    const lineKey = activeLine?.dataset.line;
    const quantityButtons = lineKey ? $$('[data-line]', drawerBody).filter(button => button.dataset.line === lineKey) : [];
    const controlIndex = quantityButtons.indexOf(activeLine);
    const lineIndex = drawerBody ? $$('.line', drawerBody).indexOf(active?.closest?.('.line')) : -1;
    ['#drawer-body', '#drawer-foot'].forEach(sel => { const src = $(sel, doc), dst = $(sel); if (src && dst) dst.replaceWith(src); });
    const updatedBody = $('#drawer-body');
    if (lineKey && $('#drawer')?.classList.contains('open')) {
      const sameLine = $$('[data-line]', updatedBody).filter(button => button.dataset.line === lineKey);
      const fallbackLine = $$('.line', updatedBody)[Math.max(0, lineIndex)];
      const focus = sameLine[controlIndex] || $('[data-line]', fallbackLine || updatedBody) || $('#drawer-close');
      focus?.focus({ preventScroll: true });
    }
    if (updatedBody) updatedBody.scrollTop = scrollTop;
    const count = +($('[data-cart-count]', doc)?.textContent || 0);
    $$('[data-clear-cart]', $('#drawer')).forEach(form => { form.hidden = count === 0; });
    updateBadge(count, bump);
  }
  const main = $('[data-cart-section]');
  if (main && sections[main.dataset.cartSection]) {
    const src = $('#main-cart', parse(sections[main.dataset.cartSection]));
    if (src) { src.querySelectorAll('[data-fade],.reveal-img').forEach(e => e.classList.add('in')); main.replaceWith(src); }
  }
}
async function cartPost(url, body) {
  let res;
  try {
    res = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
  } catch (cause) {
    const error = new Error(P.strings.purchaseUncertain || 'We could not confirm the add. Check your cart before trying again.');
    error.kind = 'ambiguous';
    error.cause = cause;
    throw error;
  }

  let data = null;
  try {
    data = await res.json();
  } catch (cause) {
    const ambiguous = res.ok || res.status >= 500;
    const error = new Error(ambiguous ? (P.strings.purchaseUncertain || 'We could not confirm the add. Check your cart before trying again.') : (P.strings.purchaseError || 'We could not add this item. Please try again.'));
    error.kind = ambiguous ? 'ambiguous' : 'rejected';
    error.cause = cause;
    throw error;
  }
  if (!res.ok) {
    const ambiguous = res.status >= 500;
    const error = new Error(ambiguous
      ? (P.strings.purchaseUncertain || 'We could not confirm the add. Check your cart before trying again.')
      : ((data && (data.description || data.message)) || P.strings.purchaseError || 'We could not add this item. Please try again.'));
    error.kind = ambiguous ? 'ambiguous' : 'rejected';
    throw error;
  }
  return data;
}
async function addToCart(id, quantity, bump = true) {
  const items = Array.isArray(id) ? id : [{ id: +id, quantity: +quantity || 1 }];
  const data = await cartPost(P.routes.cartAdd + '.js', { items, sections: cartSections() });
  applySections(data.sections, bump);
  return data;
}
let cartEditPending = false;
async function editCart(action) {
  if (cartEditPending) return;
  cartEditPending = true;
  const scopes = [$('#drawer'), $('#main-cart')].filter(Boolean);
  const controls = scopes.flatMap(scope => $$('[data-line],[data-clear-cart] button,button[name="checkout"]', scope))
    .map(element => ({ element, disabled: element.disabled }));
  scopes.forEach(scope => scope.setAttribute('aria-busy', 'true'));
  controls.forEach(({ element }) => { element.disabled = true; });
  try { await action(); }
  finally {
    controls.forEach(({ element, disabled }) => { if (element.isConnected) element.disabled = disabled; });
    scopes.forEach(scope => scope.removeAttribute('aria-busy'));
    cartEditPending = false;
  }
}
async function changeLine(key, quantity) {
  await editCart(async () => {
    const data = await cartPost(P.routes.cartChange + '.js', { id: key, quantity: +quantity, sections: cartSections() });
    applySections(data.sections, false);
  });
}
async function clearCart(form) {
  if (cartEditPending) return;
  const button = $('button', form), label = button.textContent;
  const scope = form.closest('#drawer,#main-cart') || form;
  $('[data-cart-clear-error]', scope)?.remove();
  button.textContent = form.dataset.clearingLabel;
  try {
    await editCart(async () => {
      const sections = cartSections();
      const data = await cartPost((P.routes.cart || '/cart') + '/clear.js', { sections, sections_url: location.pathname });
      updateBadge(data.item_count, false);
      // A clear can succeed even if Shopify cannot render a requested section.
      if (sections.some(id => !data.sections?.[id])) { location.reload(); return; }
      applySections(data.sections, false);
      const target = $('#drawer')?.classList.contains('open') ? $('#drawer-close') : $('#cart-lines a');
      target?.focus({ preventScroll: true });
    });
  } catch (error) {
    const message = document.createElement('p');
    message.className = 'form-msg'; message.setAttribute('role', 'alert'); message.setAttribute('data-cart-clear-error', '');
    message.textContent = form.dataset.errorLabel;
    ($('#drawer-body', scope) || $('#cart-lines', scope) || scope).prepend(message);
  } finally { if (button.isConnected) button.textContent = label; }
}

/* ============ Purchase state ============ */
const purchaseStates = new WeakMap();
let purchasePageBlocked = false;
function purchaseControls(form) {
  const controls = $$('button', form);
  if (form.hasAttribute('data-product-form')) controls.push(...$$('input[type="radio"][name="id"]', form));
  const id = form.getAttribute('id');
  if (id) $$('[form]', document).forEach(control => { if (control.getAttribute('form') === id) controls.push(control); });
  return [...new Set(controls)];
}
function purchaseState(form) {
  let state = purchaseStates.get(form);
  if (!state) { state = { pending: false, blocked: false, controls: [] }; purchaseStates.set(form, state); }
  return state;
}
function rememberPurchaseControls(form, state) {
  if (state.controls.length) return;
  state.controls = purchaseControls(form).map(element => ({
    element,
    disabled: element.disabled,
    ariaDisabled: element.getAttribute('aria-disabled'),
  }));
}
function blockPurchaseForm(form) {
  const state = purchaseState(form);
  state.blocked = true;
  rememberPurchaseControls(form, state);
  state.controls.forEach(({ element }) => { element.disabled = true; element.setAttribute('aria-disabled', 'true'); });
  form.removeAttribute('aria-busy');
  form.primeSyncPurchase?.();
}
function blockPurchasePage() {
  purchasePageBlocked = true;
  $$('[data-product-form],[data-add-form]').forEach(blockPurchaseForm);
}
function setPurchasePending(form, pending) {
  const state = purchaseState(form);
  if (pending) {
    if (purchasePageBlocked || state.blocked || state.pending) return false;
    state.pending = true;
    rememberPurchaseControls(form, state);
    state.controls.forEach(({ element }) => { element.disabled = true; element.setAttribute('aria-disabled', 'true'); });
    form.setAttribute('aria-busy', 'true');
    form.primeSyncPurchase?.();
    return true;
  }
  if (!state.pending) return;
  if (purchasePageBlocked || state.blocked) { state.pending = false; form.removeAttribute('aria-busy'); form.primeSyncPurchase?.(); return; }
  state.controls.forEach(({ element, disabled, ariaDisabled }) => {
    element.disabled = disabled;
    if (ariaDisabled === null) element.removeAttribute('aria-disabled'); else element.setAttribute('aria-disabled', ariaDisabled);
  });
  form.removeAttribute('aria-busy');
  state.pending = false;
  state.controls = [];
  form.primeSyncPurchase?.();
}
function purchaseErrorElement(scope) {
  let error = $('[data-purchase-error]', scope);
  if (!error) {
    error = document.createElement('p');
    error.className = 'form-msg';
    error.setAttribute('data-purchase-error', '');
    error.setAttribute('role', 'alert');
    error.setAttribute('aria-live', 'assertive');
    const anchor = $('[data-buy-now]', scope) || $('button[type="submit"]', scope);
    if (anchor && anchor.parentElement) anchor.parentElement.insertBefore(error, anchor); else scope.appendChild(error);
  }
  return error;
}
function clearPurchaseError(scope) {
  const error = $('[data-purchase-error]', scope);
  if (error) { error.hidden = true; error.textContent = ''; }
}
function showPurchaseError(scope, error) {
  const definite = error && error.kind === 'rejected';
  const message = definite ? P.strings.purchaseError : P.strings.purchaseUncertain;
  const target = purchaseErrorElement(scope);
  target.replaceChildren();
  target.hidden = false;
  target.textContent = message || (definite ? 'We could not add this item. Please try again.' : 'We could not confirm the add. Check your cart before trying again.');
  if (!definite) {
    const link = document.createElement('a');
    link.setAttribute('href', P.routes.cart || '/cart');
    link.textContent = ` ${P.strings.viewCart || 'View cart'}`;
    target.appendChild(link);
  }
}
async function runPurchase(form, id, quantity, mode) {
  if (purchasePageBlocked || purchaseState(form).blocked) {
    blockPurchaseForm(form);
    showPurchaseError(form, { kind: 'ambiguous' });
    return false;
  }
  if (!setPurchasePending(form, true)) return false;
  clearPurchaseError(form);
  let keepPending = false;
  try {
    await addToCart(id, quantity, mode !== 'buy');
    if (mode === 'buy') {
      keepPending = true;
      location.href = (P.routes.root || '/').replace(/\/$/, '') + '/checkout';
    } else openDrawer();
    return true;
  } catch (error) {
    if (Array.isArray(id) && error && error.kind === 'rejected') error.kind = 'ambiguous';
    if (!error || error.kind !== 'rejected') blockPurchasePage();
    showPurchaseError(form, error);
    return false;
  } finally {
    if (!keepPending) setPurchasePending(form, false);
  }
}

/* ============ Product page ============ */
function productMoney(cents, format = '{{amount}}') {
  const formats = {
    amount: [2, ',', '.'], amount_no_decimals: [0, ',', '.'],
    amount_with_comma_separator: [2, '.', ','], amount_no_decimals_with_comma_separator: [0, '.', ','],
    amount_with_apostrophe_separator: [2, "'", '.'], amount_with_space_separator: [2, ' ', ','],
    amount_no_decimals_with_space_separator: [0, ' ', ','], amount_with_period_and_space_separator: [2, ' ', '.'],
  };
  return format.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, token) => {
    const [decimals, group, separator] = formats[token] || formats.amount;
    const [whole, fraction] = (Number(cents) / 100).toFixed(decimals).split('.');
    return whole.replace(/\B(?=(\d{3})+(?!\d))/g, group) + (fraction ? separator + fraction : '');
  });
}
function initProduct(scope = document) {
  const form = $('[data-product-form]', scope); if (!form) return;
  if (form.dataset.initialized) return;
  form.dataset.initialized = 'true';
  const priceEl = $('[data-price]', scope), stickPrice = $('[data-stick-price]');
  const qtyInput = $('[data-qty-input]', form), qtyLabel = $('[data-qty-label]', form);
  const variants = JSON.parse($('[data-product-variants]', scope)?.textContent || '[]');
  const packs = JSON.parse($('[data-product-pack-labels]', scope)?.textContent || '{}');
  const variantId = () => (form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"]')).value;
  const selectedVariant = () => variants.find(variant => String(variant.id) === variantId());
  const stick = $('#stick');
  const sync = () => {
    const variant = selectedVariant();
    const radio = form.querySelector('input[name="id"]:checked');
    if (priceEl && variant) priceEl.textContent = productMoney(variant.price, form.dataset.moneyFormat);
    else if (priceEl && radio?.dataset.price) priceEl.textContent = radio.dataset.price;
    if (stickPrice && variant) stickPrice.textContent = productMoney(variant.price * (+qtyInput.value || 1), form.dataset.moneyFormat);
    const selection = $('[data-stick-selection]');
    if (selection && variant) selection.textContent = (stick?.dataset.selectionTemplate || '[pack] × [quantity]')
      .replace('[pack]', packs[variant.id] || variant.title).replace('[quantity]', qtyInput.value);
    const sku = $('[data-sku]', scope);
    if (sku && variant) sku.textContent = variant.sku || '';
    const state = purchaseState(form);
    const unavailable = variant ? !variant.available : false;
    purchaseControls(form).filter(button => button.hasAttribute('data-product-add') || button.hasAttribute('data-buy-now')).forEach(button => {
      button.disabled = unavailable || state.pending || state.blocked || purchasePageBlocked;
      if (button.hasAttribute('data-product-add')) {
        button.textContent = state.pending ? form.dataset.addingLabel : unavailable ? form.dataset.soldOutLabel : form.dataset.addLabel;
        if (state.pending) button.setAttribute('aria-busy', 'true'); else button.removeAttribute('aria-busy');
      }
    });
  };
  form.primeSyncPurchase = sync;

  $$('input[type="radio"][name="id"]', form).forEach(r => r.addEventListener('change', () => {
    sync();
    const url = new URL(location.href); url.searchParams.set('variant', r.value); history.replaceState(history.state, '', url);
  }));
  $$('[data-pq]', form).forEach(b => b.addEventListener('click', () => {
    const q = clamp((+qtyInput.value || 1) + (+b.dataset.pq), 1, 99); qtyInput.value = q; qtyLabel.textContent = q;
    sync();
  }));
  qtyInput.addEventListener('change', () => {
    qtyInput.value = clamp(+qtyInput.value || 1, 1, 99); qtyLabel.textContent = qtyInput.value; sync();
  });
  form.addEventListener('submit', async e => {
    e.preventDefault();
    if (selectedVariant()?.available === false) return;
    await runPurchase(form, variantId(), qtyInput.value, 'add');
  });
  $('[data-buy-now]', form)?.addEventListener('click', async e => {
    e.preventDefault();
    if (selectedVariant()?.available === false) return;
    await runPurchase(form, variantId(), qtyInput.value, 'buy');
  });

  const img = $('#main-img'), wrap = $('#main-wrap');
  $$('[data-thumb]', scope).forEach(b => b.addEventListener('click', () => {
    $$('[data-thumb]', scope).forEach(x => x.setAttribute('aria-current', String(x === b)));
    if (!img) return;
    img.style.opacity = 0;
    setTimeout(() => {
      img.removeAttribute('srcset');
      img.src = b.dataset.src;
      img.alt = b.dataset.alt || '';
      wrap.classList.add('in');
      img.style.opacity = 1;
    }, 180);
    const count = $('[data-gallery-count]', scope);
    if (count && count.dataset.galleryFormat) {
      count.textContent = count.dataset.galleryFormat
        .replace('[current]', b.dataset.galleryIndex || '1')
        .replace('[total]', b.dataset.galleryTotal || '1');
    }
  }));

  stick?.classList.add('show');
  sync();

  const zoom = $('#product-zoom'), zoomImage = $('[data-zoom-image]', zoom || scope);
  const zoomToggle = $('[data-zoom-toggle]', zoom || scope);
  if (zoom && wrap && img && zoomImage) {
    const resetZoom = () => {
      zoom.classList.remove('is-zoomed');
      zoomToggle?.setAttribute('aria-pressed', 'false');
      if (zoomToggle) zoomToggle.textContent = zoomToggle.dataset.zoomIn;
    };
    wrap.addEventListener('click', () => {
      const src = new URL(img.currentSrc || img.src, location.href);
      src.searchParams.set('width', '2000');
      zoomImage.src = src.href; zoomImage.alt = img.alt;
      resetZoom(); zoom.showModal(); lockScroll(true);
    });
    $('[data-zoom-close]', zoom)?.addEventListener('click', () => zoom.close());
    zoom.addEventListener('close', () => { resetZoom(); lockScroll(false); wrap.focus({ preventScroll: true }); });
    zoom.addEventListener('click', event => { if (event.target === zoom) zoom.close(); });
    zoomToggle?.addEventListener('click', () => {
      const expanded = zoom.classList.toggle('is-zoomed');
      zoomToggle.setAttribute('aria-pressed', String(expanded));
      zoomToggle.textContent = expanded ? zoomToggle.dataset.zoomOut : zoomToggle.dataset.zoomIn;
    });
  }
}

/* ============ Collection: sort, brand select, load more ============ */
function initCollection() {
  $('[data-sort]')?.addEventListener('change', e => {
    const url = new URL(location.href); url.searchParams.set('sort_by', e.target.value); url.searchParams.delete('page'); location.href = url;
  });
  $('[data-nav-select]')?.addEventListener('change', e => { location.href = e.target.value; });

  const panel = $('#filter-panel'), openButton = $('[data-filters-open]');
  if (!panel || !openButton) return;
  const closeButton = $('[data-filters-close]', panel);
  const mobileFilters = window.matchMedia('(max-width: 899px)');
  let openedAsModal = false;
  const setExpanded = open => openButton.setAttribute('aria-expanded', String(open));
  const syncPanelMode = () => {
    if (mobileFilters.matches) {
      if (panel.open) panel.close();
      if (openedAsModal) lockScroll(false);
      openedAsModal = false;
      setExpanded(false);
      return;
    }
    if (openedAsModal) {
      if (panel.open) panel.close();
      lockScroll(false);
    }
    openedAsModal = false;
    if (!panel.open) panel.setAttribute('open', '');
    setExpanded(false);
  };
  syncPanelMode();
  mobileFilters.addEventListener('change', syncPanelMode);
  openButton.addEventListener('click', () => {
    if (!mobileFilters.matches || panel.open) return;
    if (typeof panel.showModal === 'function') {
      panel.showModal();
      openedAsModal = true;
      lockScroll(true);
      setExpanded(true);
    }
  });
  closeButton?.addEventListener('click', () => { if (panel.open) panel.close(); });
  panel.addEventListener('click', e => {
    if (openedAsModal && e.target === panel) panel.close();
  });
  panel.addEventListener('keydown', e => {
    if (!openedAsModal || e.key !== 'Tab') return;
    const controls = $$('a[href],button,input,select,textarea,summary,[tabindex]', panel)
      .filter(el => !el.disabled && el.tabIndex >= 0 && el.getAttribute('aria-disabled') !== 'true' && el.getClientRects().length > 0);
    if (!controls.length) return;
    const first = controls[0], last = controls[controls.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  panel.addEventListener('close', () => {
    if (openedAsModal) lockScroll(false);
    openedAsModal = false;
    setExpanded(false);
  });
}
async function loadMore(a) {
  a.setAttribute('aria-busy', 'true');
  const doc = new DOMParser().parseFromString(await (await fetch(a.href)).text(), 'text/html');
  const grid = $('#product-grid'), cards = $$('#product-grid > .card', doc);
  cards.forEach(c => grid.appendChild(c));
  const count = $('[data-count]', doc); if (count) $('[data-count]').textContent = count.textContent;
  $('[data-more-wrap]').replaceWith($('[data-more-wrap]', doc));
  motion(grid);
}

/* ============ Global events ============ */
function backToTop() {
  if (root.classList.contains('lock')) return;
  const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  ($('#head .brand') || $('#main'))?.focus({ preventScroll: true });
  if (lenis) lenis.scrollTo(0, { immediate: Boolean(reduceMotion) });
  else window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
}
function bind() {
  document.addEventListener('click', e => {
    if (!e.target.closest('.fab')) setFab(false);
    const t = e.target.closest('a,button,[data-close-drawer]'); if (!t) return;
    if (t.hasAttribute('data-back-top')) { e.preventDefault(); backToTop(); return; }
    if (t.id === 'skip') { e.preventDefault(); $('#main').focus(); return; }
    if (t.hasAttribute('data-open-drawer')) { if (openDrawer()) e.preventDefault(); return; }
    if (t.hasAttribute('data-close-drawer')) { closeDrawer(); return; }
    if (t.id === 'menu-btn') { toggleMenu(); return; }
    if (t.hasAttribute('data-search-toggle')) { e.preventDefault(); const p = $('#search-panel'); if (p) setSearch(p.hidden); return; }
    if (t.hasAttribute('data-search-close')) { setSearch(false); return; }
    if (t.hasAttribute('data-fab-toggle')) { setFab($('#contact-pop').hidden); return; }
    if (t.hasAttribute('data-fab-close')) { setFab(false); $('[data-fab-toggle]')?.focus(); return; }
    if (t.dataset.line) { e.preventDefault(); changeLine(t.dataset.line, t.dataset.qty).catch(() => location.reload()); return; }
    if (t.hasAttribute('data-load-more')) { e.preventDefault(); loadMore(t).catch(() => { location.href = t.href; }); return; }
    if (t.tagName === 'A' && t.closest('.mnav')) closeMenu();
  });
  document.addEventListener('submit', e => {
    const clearForm = e.target.closest('[data-clear-cart]');
    if (clearForm) { e.preventDefault(); clearCart(clearForm); return; }
    const f = e.target.closest('[data-add-form]'); if (!f) return;
    e.preventDefault();
    runPurchase(f, f.elements.id.value, f.elements.quantity.value, 'add');
  });
  document.addEventListener('focusin', e => containDrawerFocus(e));
  document.addEventListener('keydown', e => { containDrawerFocus(e); if (e.key === 'Escape') { closeDrawer(); closeMenu(); setSearch(false); if (!$('#contact-pop')?.hidden) { setFab(false); $('[data-fab-toggle]')?.focus(); } } });
  window.addEventListener('resize', () => { dirty = true; });
  // Keep the badge right when the page is restored from the back/forward cache.
  window.addEventListener('pageshow', e => { if (e.persisted) fetch((P.routes.cart || '/cart') + '.js').then(r => r.json()).then(c => updateBadge(c.item_count)).catch(() => {}); });
}

/* ============ Shopify theme editor ============ */
document.addEventListener('shopify:section:load', e => { motion(e.target); $$('[data-split],[data-fade],.reveal-img', e.target).forEach(x => x.classList.add('in')); initProduct(e.target); });

/* ============ Boot ============ */
async function boot() {
  if ('scrollRestoration' in history) history.scrollRestoration = 'auto';
  if (!reduced && window.Lenis) {
    try {
      lenis = new window.Lenis({
        duration: 1.15,
        easing: t => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        smoothWheel: true,
        wheelMultiplier: 0.95,
        prevent: element => element.classList?.contains('prime-home-hero__copy') && element.scrollHeight > element.clientHeight
      });
      root.classList.add('lenis', 'lenis-smooth');
    } catch (e) { lenis = null; }
  }
  bind();
  initProduct();
  initCollection();
  runIntro();
  requestAnimationFrame(loop);
  await introGate;
  motion();
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
